"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ContextMenu = _interopRequireDefault(require("./ContextMenu"));
var Styled = _interopRequireWildcard(require("./styles/buttonGroup"));
var _constants = require("./constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ButtonGroup = ({
  children,
  fullWidthButton = false,
  visibleButtonsLimit = 5,
  leftVisibleButtonsLimit = 1,
  strategy = 'right',
  nativeComponents = false,
  className
}) => {
  const compactChildren = (0, _react.useMemo)(() => _react.Children.toArray(children).filter(child => !!child), [children]);
  const isDefaultButtons = compactChildren.every(btn => btn.props.mode === _constants.TYPES.DEFAULT);
  const rightVisibleChildren = [];
  const leftVisibleChildren = [];
  const rightContextMenuItems = [];
  const leftContextMenuItems = [];
  const rightContextMenuComps = [];
  const leftContextMenuComps = [];
  _react.Children.forEach(compactChildren, (child, index) => {
    if (child.props.strategy === 'left') {
      if (leftVisibleChildren.length < leftVisibleButtonsLimit) {
        leftVisibleChildren.push((0, _react.cloneElement)(child, {
          key: index,
          ...child.props
        }));
      } else if (!nativeComponents) {
        leftContextMenuItems.push({
          disabled: child.props.disabled,
          title: child.props.title,
          onClick: child.props.onClick
        });
      } else {
        leftContextMenuComps.push(child);
      }
    }
    if (child.props.strategy !== 'left') {
      if (rightVisibleChildren.length < visibleButtonsLimit) {
        rightVisibleChildren.push((0, _react.cloneElement)(child, {
          key: index,
          ...child.props
        }));
      } else if (!nativeComponents) {
        rightContextMenuItems.push({
          disabled: child.props.disabled,
          title: child.props.title,
          onClick: child.props.onClick
        });
      } else {
        rightContextMenuComps.push(child);
      }
    }
  });
  return _react.default.createElement(Styled.ButtonArea, {
    className: className,
    leftCount: leftVisibleChildren.length,
    rightCount: rightVisibleChildren.length,
    isContextFromLeft: leftContextMenuItems.length > 0
  }, leftVisibleChildren.length > 0 && _react.default.createElement(Styled.ButtonGroup, {
    strategy: "left",
    fullWidth: fullWidthButton,
    isDefaultButtons: isDefaultButtons
  }, leftVisibleChildren, (leftContextMenuItems.length || leftContextMenuComps.length) > 0 && _react.default.createElement(_ContextMenu.default, {
    data: leftContextMenuItems,
    comps: leftContextMenuComps
  })), _react.default.createElement(Styled.ButtonGroup, {
    strategy: strategy,
    fullWidth: fullWidthButton,
    isDefaultButtons: isDefaultButtons
  }, rightVisibleChildren, (rightContextMenuItems.length || rightContextMenuComps.length) > 0 && _react.default.createElement(_ContextMenu.default, {
    data: rightContextMenuItems,
    comps: rightContextMenuComps
  })));
};
var _default = exports.default = (0, _react.memo)(ButtonGroup);